import React from 'react';
import EDBubbleChart from '../../../../../BaseComponents/Charts/BubbleChart/EDBubbleChart';
import GraphPanel from '../GraphPanel/GraphPanel';
import {
  FormatterCallbackFunction,
  AxisLabelsFormatterContextObject,
  SeriesBubbleOptions,
  DrilldownEventObject,
} from 'highcharts';

interface IProps {
  title?: string;
  link?: string;
  yAxisLabel: string;
  formater?: FormatterCallbackFunction<AxisLabelsFormatterContextObject>;
  categories: string[];
  series: SeriesBubbleOptions[];
  drilldownEvent?: (event: DrilldownEventObject) => void;
}

class BubbleChartPanel extends React.PureComponent<IProps> {
  render() {
    return (
      <GraphPanel type="bubble" title={this.props.title} link={this.props.link}>
        <EDBubbleChart
          yAxisLabel="Värde - kr"
          categories={this.props.categories}
          series={this.props.series}
          drilldownEvent={this.props.drilldownEvent}
          formater={this.props.formater}
        />
      </GraphPanel>
    );
  }
}

export default BubbleChartPanel;
